/**
 * SUNDAY FLOOR — product-details-accordion.js
 * Same reasoning as footer.js: <details open> is the correct no-JS-safe
 * default, and native <details> closed-state can't be forced with author
 * CSS alone, so a small script enforces the intended per-breakpoint state
 * — here, only the first panel open on desktop, all closed on mobile.
 * Scoped per .sf-details container so the section stays safe to duplicate.
 */

document.querySelectorAll('.sf-details').forEach(initDetailsGroup);

function initDetailsGroup(container) {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const groups = container.querySelectorAll('[data-details-accordion]');

  function sync(event) {
    const isDesktop = event ? event.matches : desktopQuery.matches;
    groups.forEach((details, index) => {
      details.open = isDesktop ? index === 0 : false;
    });
  }

  sync();
  desktopQuery.addEventListener('change', sync);
}
